import React, { Component } from 'react';
import axios from 'axios';


class CategoryItem extends Component
{

	constructor(props)
	{
		super(props);

		this.state = {
			categoryValue: props.value,
			categoryId: props.catId,
			postId: 0,
			catData: null
		}
	}



	componentDidMount()
	{
		this.setState({
			catData: this._getPostsByTermIdData
		});
	}


	// http://soko.l/api/core/get_posts_by_catID/?post_type=references&taxonomy=references_category&term_id=25&posts_per_page=-1




	_getPostsByTermIdData(termId)
	{
		// let id = 1011;

		let encodedURI = encodeURI(
			'http://soko.l/api/core/get_posts_by_catID/?post_type=references&taxonomy=references_category&term_id='+ termId +'&posts_per_page=-1'
		);

		return axios.get(encodedURI)
			.then(
				(response) => {
					// console.log(response.data);
					return response.data
				}
			)
			.catch(err => console.log(err));

		// return this.state.repos;

	}

	_onClick(e)
	{
		this.props.onClick(e);

		// this._getPostsByTermIdData(this.state.categoryId);

		// this.props.clickEventHandler(e);
	};



	render()
	{
		return (
			/*<li onClick={ () => {this._onClick(this.state.categoryId)} } data-id={this.state.categoryId}>{this.state.categoryValue}</li>*/
			<li onClick={this._onClick.bind(this)} data-id={this.props.catId}><span>{this.props.value}</span></li>
		)
	}
}

export default CategoryItem;


// WEBPACK FOOTER //
// ./src/component/CategoryItem.js